import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            漫画分类
          </h2>
          <p className="text-sm text-foreground-500 mt-2">探索你喜欢的漫画类型</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-6 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 group-hover:bg-accent-200 transition-colors">
                <i className={`${cat.icon} text-xl text-accent-600`}></i>
              </div>
              <div className="text-center">
                <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors">
                  {cat.name}
                </span>
                <p className="text-xs text-foreground-400 mt-0.5">{cat.count}部作品</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}